(function () {
  if (window.__beastKitToggleInit) return;
  window.__beastKitToggleInit = true;

  var SWAP_SELECTOR = 'product-info';

  function reExecuteScripts(root) {
    root.querySelectorAll('script').forEach(function (oldScript) {
      var newScript = document.createElement('script');
      for (var i = 0; i < oldScript.attributes.length; i++) {
        var attr = oldScript.attributes[i];
        newScript.setAttribute(attr.name, attr.value);
      }
      if (oldScript.textContent) newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }

  function setActive(group, triggerBtn) {
    if (!group) return;
    group.querySelectorAll('[data-kit-toggle-url]').forEach(function (b) {
      var on = b === triggerBtn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  async function swapKit(url, triggerBtn) {
    var current = document.querySelector(SWAP_SELECTOR);
    if (!current) {
      window.location.href = url;
      return;
    }

    var group = triggerBtn && triggerBtn.closest('[data-kit-toggle]');
    setActive(group, triggerBtn);
    if (triggerBtn) triggerBtn.setAttribute('aria-busy', 'true');
    current.classList.add('is-swapping');

    // Preserve customer-entered name/number across the kit swap. The inputs
    // sit inside the custom phone-case selector which gets wiped & rebuilt,
    // so we snapshot the values now and write them back after rebuild.
    var prevNameEl = document.getElementById('custom-name');
    var prevNumberEl = document.getElementById('custom-number');
    var savedName = prevNameEl ? prevNameEl.value : '';
    var savedNumber = prevNumberEl ? prevNumberEl.value : '';

    // Preserve the selected phone model. Each kit has its own variant IDs, so
    // we save the option *title* (e.g. "iPhone 15 Pro") and let the rebuilt
    // selector match it against the new product's variants by title.
    var prevModelSelect = document.querySelector('.phone-case-model-select');
    var savedModelTitle = '';
    if (prevModelSelect && prevModelSelect.value) {
      var selOpt = prevModelSelect.options[prevModelSelect.selectedIndex];
      if (selOpt) {
        savedModelTitle = selOpt.textContent.replace(/\s*\(Sold Out\)\s*$/i, '').trim();
      }
    }
    window.__beastPhoneCaseRestoreModel = savedModelTitle || null;

    try {
      var res = await fetch(url, { headers: { Accept: 'text/html' }, credentials: 'same-origin' });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector(SWAP_SELECTOR);
      if (!next) throw new Error('No <product-info> in response');

      // Pre-paint the case-preview on the detached new product-info so the
      // saved name / number appears immediately when it's inserted. Without
      // this the server-rendered defaults ("Your Name" + default number)
      // flash for ~125ms until the case-preview polling catches up.
      if (savedName) {
        var nextNameEl = next.querySelector('[id^="preview-name-"]');
        if (nextNameEl) {
          var displayName = savedName.toUpperCase();
          var nextTextPath = nextNameEl.querySelector('textPath');
          if (nextTextPath) {
            nextTextPath.textContent = displayName;
          } else {
            nextNameEl.textContent = displayName;
          }
        }
      }
      if (savedNumber) {
        var nextNumberEl = next.querySelector('[id^="preview-number-"]');
        if (nextNumberEl) nextNumberEl.textContent = savedNumber;
      }

      current.replaceWith(next);
      reExecuteScripts(next);

      // Rebuild the custom phone-model selector (Apple / Samsung / Google tabs
      // + custom name/number inputs) for the new product. The function is
      // defined globally in layout/theme.liquid; reading variants from
      // window.__beastPhoneCaseVariants which the new section's inline script
      // has just refreshed.
      if (typeof window.initPhoneCaseSelector === 'function') {
        try { window.initPhoneCaseSelector(); }
        catch (e) { console.error('[kit-toggle] initPhoneCaseSelector threw', e); }
      }

      // Restore the captured name/number onto the freshly-built inputs. The
      // case-preview's wiring polls for these inputs and calls update() as
      // soon as it finds them, which will read these restored values and
      // render them onto the new kit's case mockup.
      if (savedName || savedNumber) {
        var newName = document.getElementById('custom-name');
        var newNumber = document.getElementById('custom-number');
        if (newName) {
          newName.value = savedName;
          newName.dispatchEvent(new Event('input', { bubbles: true }));
        }
        if (newNumber) {
          newNumber.value = savedNumber;
          newNumber.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }

      history.pushState({ beastKitSwap: true }, '', url);
      if (doc.title) document.title = doc.title;

      // Sync is-active state across every kit-toggle trigger on the page —
      // including the larger card picker outside <product-info>, which isn't
      // re-rendered by the swap. Match by URL pathname so query strings or
      // accidental trailing slashes don't break the comparison.
      try {
        var newPath = new URL(url, window.location.origin).pathname.replace(/\/$/, '');
        document.querySelectorAll('[data-kit-toggle-url]').forEach(function (btn) {
          try {
            var btnPath = new URL(btn.dataset.kitToggleUrl, window.location.origin).pathname.replace(/\/$/, '');
            var on = btnPath === newPath;
            btn.classList.toggle('is-active', on);
            btn.setAttribute('aria-selected', on ? 'true' : 'false');
          } catch (e) {}
        });
      } catch (e) {}

      // Optional: scroll to page top if the trigger opted in. The inline pill
      // toggle inside <product-info> intentionally stays put; the card picker
      // sets data-kit-toggle-scroll="top" so the customer sees the full page
      // (incl. nav) from the start when they choose a different kit.
      if (triggerBtn && triggerBtn.dataset.kitToggleScroll === 'top') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      if (triggerBtn) triggerBtn.removeAttribute('aria-busy');
    } catch (err) {
      console.error('[kit-toggle] swap failed, falling back to navigation', err);
      window.location.href = url;
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kit-toggle-url]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-active')) return;
    var url = btn.dataset.kitToggleUrl;
    if (url) swapKit(url, btn);
  });

  window.addEventListener('popstate', function (event) {
    if (event.state && event.state.beastKitSwap) window.location.reload();
  });
})();
